import { questionForStep } from '../../guided-mode/utils/assessment-definition';
import type {
  GuidedModeDefinition,
  GuidedModeMedia,
  GuidedModeStep,
} from '../../guided-mode/types/guided-mode.types';

/** Resolve presentation media without changing the questions selected by Text. */
export function questionMediaFor(
  definition: GuidedModeDefinition | null | undefined,
  observationCode: string,
  promptToken?: string,
): GuidedModeMedia | null {
  const candidates: Array<{ media: GuidedModeMedia | null; promptTokens: string[] }> = [];

  function visit(steps: GuidedModeStep[], groupMedia: GuidedModeMedia | null): void {
    for (const step of steps) {
      const media = step.media ?? groupMedia;
      const question = questionForStep(definition, step);
      if (question && definition?.concepts[question.conceptId]?.code?.code === observationCode) {
        const promptTokens = [question.promptToken];
        if ('standalonePromptToken' in question
          && typeof question.standalonePromptToken === 'string') {
          promptTokens.push(question.standalonePromptToken);
        }
        candidates.push({ media, promptTokens });
      }
      if (step.steps) visit(step.steps, media);
    }
  }

  visit(definition?.assessment?.steps ?? [], null);
  const matchingPrompt = promptToken
    ? candidates.find(candidate => candidate.promptTokens.includes(promptToken))
    : undefined;
  return (matchingPrompt ?? candidates[0])?.media ?? null;
}
